import { Dialog, DialogContent } from "@/components/ui/dialog";

interface DocumentPreviewProps {
  previewUrl: string | null;
  onClose: () => void;
}

export const DocumentPreview = ({ previewUrl, onClose }: DocumentPreviewProps) => {
  if (!previewUrl) return null;

  return (
    <Dialog open={!!previewUrl} onOpenChange={onClose}>
      <DialogContent className="max-w-4xl">
        <iframe
          src={previewUrl}
          className="w-full h-[80vh]"
          title="Document Preview"
        />
      </DialogContent>
    </Dialog>
  );
};